import type { ThemeConfig } from 'antd';

/**
 * AntD 主题 token：主色对齐主站 Tailwind teal 色板（--color-primary-600: #0d9488），
 * 圆角与字体风格保持与主站一致的现代观感。
 */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0d9488',
    colorInfo: '#0d9488',
    colorLink: '#0d9488',
    borderRadius: 8,
    fontSize: 14,
    colorBgLayout: '#f5f7f8',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#001529',
    },
    Card: {
      headerFontSize: 16,
    },
  },
};